import React, {useContext, useState} from "react";
import {Box, Button, CircularProgress, Stack, TextField} from "@mui/material";
import {toast} from "react-toastify";
import {SignInContext} from "../../../context/SignInContext";
import {AuthLayout} from "../components/AuthLayout";
import {fieldSx, noticeSx, primaryButtonSx, secondaryButtonSx} from "../components/authStyles";

export const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [sentTo, setSentTo] = useState("");
  const [loading, setLoading] = useState(false);
  const {onForgotPassword} = useContext(SignInContext);

  const submitHandle = async (e) => {
    e.preventDefault();

    const normalizedEmail = email.trim();
    if (!normalizedEmail) {
      toast.error("Please enter email address");
      return;
    }

    try {
      setLoading(true);
      await onForgotPassword({email: normalizedEmail});
      setSentTo(normalizedEmail);
      setEmail("");
    } catch (err) {
      toast.error(err?.message || "Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // After sending: say what happens next, with a way to try another address
  if (sentTo) {
    return (
      <AuthLayout
        kicker={"Reset password"}
        title={"Check your email"}
        description={"If there is an account for this address, a link to choose a new password is on its way."}
        prompt={"Remembered it?"}
        linkText={"Sign in"}
        linkTo={"/login"}
        preserveSearch={false}
      >
        <Stack gap={1.5}>
          <Box sx={noticeSx}>
            We sent the link to <b>{sentTo}</b>. It can take a minute. Check your spam folder if you don't see it.
          </Box>
          <Button fullWidth sx={secondaryButtonSx} onClick={() => setSentTo("")}>
            Use a different email
          </Button>
        </Stack>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      kicker={"Reset password"}
      title={"Forgot your password?"}
      description={"Enter your email and we'll send you a link to choose a new one."}
      prompt={"Remembered it?"}
      linkText={"Sign in"}
      linkTo={"/login"}
      preserveSearch={false}
    >
      <Stack component="form" onSubmit={submitHandle} direction="column" gap={0.5} sx={{width: "100%"}}>
        <TextField
          variant="filled"
          required
          autoFocus
          fullWidth
          type="email"
          label="Email"
          autoComplete="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="you@company.com"
          helperText={" "}
          sx={fieldSx}
        />
        <Button
          fullWidth
          type="submit"
          disabled={loading || !email.trim()}
          sx={primaryButtonSx}
          startIcon={loading ? <CircularProgress size={16} color="inherit"/> : null}
        >
          Send reset link
        </Button>
      </Stack>
    </AuthLayout>
  );
};
